import React from "react";
import { Modal, Table } from "antd";
import { DownloadListItem } from "../../../../../../service/exam";
import { ColumnProps } from "antd/es/table";
import { ModalProps } from "antd/es/modal";

interface ShiftModalProps extends ModalProps {
    data: DownloadListItem[];
}

export default function DownloadModal({ data, ...props }: ShiftModalProps) {
    const columns: ColumnProps<DownloadListItem>[] = [
        { title: "时间", dataIndex: "time" },
        {
            title: "附件",
            dataIndex: "fileName",
            render: (_, item) => (
                <a href={item.fileUrl} target="_blank">
                    {item.fileName}
                </a>
            )
        }
    ];

    return (
        <Modal title="下载附件记录" footer={false} {...props}>
            <Table
                rowKey="time"
                columns={columns}
                dataSource={data}
                pagination={false}
                scroll={{ y: 400 }}
            />
        </Modal>
    );
}
